import { useTranslation } from "react-i18next";
import { platformDetail } from "../type";

const ProductDetailPlatformInfo = (prop: platformDetail) => {
    const { t } = useTranslation();
    return (
        <div className="store-container rounded-[3px] shadow-lg p-6">
            <h3 className="!font-semibold text-gray-900 mb-4 !text-xl">{t('store_trading_platform_info')}</h3>
            <div className="flex items-center gap-3 p-3 bg-purple-200 bg-opacity-10 rounded-lg mb-4">
                <span className="text-2xl">🚀</span>
                <div>
                    <div className="font-semibold text-black">{prop.name}</div>
                    <div className="text-sm text-gray-600">{t('store_trading_platform')}</div>
                </div>
            </div>
            <div className="space-y-2 text-sm product-text">
                {prop.features.map((feature, index) => (
                    <div key={index} className="flex items-start gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check-circle h-5 w-5 text-green-500 mt-0.5 flex-shrink-0"><circle cx="12" cy="12" r="10"></circle><path d="M9 12l2 2l4 -4"></path></svg>
                        <span>{feature}</span>
                    </div>
                ))}
            </div>
            <div className="mt-4 text-gray-500 !text-sm leading-relaxed">
                {prop.description}
            </div>
        </div>
    );
};

export default ProductDetailPlatformInfo;